module.exports = __webpack_public_path__ + "images/backgrounds/canyon/medium.4f344e7d0dedef58e178.jpg";